import _ from 'lodash';
import Vue from 'vue';
import $ from 'jquery';
import qs from 'qs';
import getParams from 'library-@/utils/get-params';
import { initWindowRvTrack } from '@/utils/rvTrack';
import { psAxios, generateExceptionRedirector } from '@patsnap/common-ps-http';
import BasicService from './services/basic-service';
import 'library-@/directives/mathJax-paper/math.directive';
import { PRESETS_TOKEN_BASE_PATENT_VIEW } from '../../../components/token-base/presets';
import { prepareTokenBase, passportInterceptManager, ejectNodeApiInterceptor } from '../../../components/token-base';
import { freeViewRequestSuccessInterceptor, freeViewRequestSignInterceptor, setIsFreeView } from 'library-@/utils/patent-view-free-judgment-util';
import { Toast } from 'patsnap-biz';
import { getI18nInstance } from './locales/i18nInstance';
import { UserCenterService } from '@patsnap-utils/biz';
import { startup } from '../../../components/startup';
import { patentViewInitApi } from 'library-@/apis/core_basic_api/patent';
import { headerService } from '@/services/header-service';

const { get, upperCase } = _;

// FIXME: 似乎没有用途
window.hasNoScrollMenu = true;

// FIXME: 似乎没有用途
if ('msPointerEnabled' in navigator || 'msDoNotTrack' in navigator) {
    $('body').addClass('isIE');
    window._noJsTooltipster = true;
    window.isIE = true;
}

initWindowRvTrack();

Vue.component('rv-track', {
    // 需要组件/directive 形式存在是因为有的EventProp数据更改是想在watch里埋，
    // 进页面不一定触发watch，会记录不准确
    // 但大部分记录是和视觉所见是直接相关的，用模版表达很直观
    render() {
        return null;
    },
    mounted() {
        let vueProps = Object.assign({}, this.$props || {}, this.$attrs || {});
        window.rvTrack(vueProps.action, { ...vueProps });
    }
});

export default async ({ beforeInit, forceSetLocale } = {}) => {
    // currentPage 用登录后重定向，若前端路由有patentId则需要替换原后端路由中的patentId
    // patentId=xxx#/yyy => patentId=yyy
    const patentIdReg = /^#\/(\-?\w+)+/;
    const patentIdInHash = get(window.location.hash.match(patentIdReg), 0);
    let searchOfPath = window.location.search;
    let params = {};
    if (patentIdInHash) {
        params = qs.parse(window.location.search.replace(/\?/, ''));
        params.patentId = patentIdInHash.substring(2);
        searchOfPath = `?${qs.stringify(params)}`;
    }

    const data = getParams();

    let patentId = params.patentId || data.patentId;

    data.currentPage = decodeURIComponent(
        qs.stringify({ currentPage: window.location.pathname + searchOfPath }).replace('currentPage=', '')
    );
    let commonInitData = {};

    function pageInit() {
        return patentViewInitApi(data)
            .then(({ data }) => data);
    }

    let locale;
    // 提前 prepareToken 区分是否登录
    let isFreeView = false;
    let isFirstTimeCheckSession = true;

    let legalConfig = [];
    try {
        await prepareTokenBase({
            ...PRESETS_TOKEN_BASE_PATENT_VIEW,
            preRedirectLogin() {
                // 只有第一次 CheckSession 时拦截跳转 用于判断 free
                if (isFirstTimeCheckSession) {
                    throw new Error('Anonymous');
                }
            }
        });
    } catch (err) {
        if (err.message === 'Anonymous') {
            // 无 token 为 free 需要去除默认内置拦截器
            isFreeView = true;
            passportInterceptManager.eject();
            ejectNodeApiInterceptor();
        }
    }
    isFirstTimeCheckSession = false;
    // 前置调用 init 判断是否有权限
    /*const viewInitData = await cacheFunction(() => pageInit().catch(generateExceptionRedirector(403, '/request_demo?project=search')), {
        cacheKey: 'patentViewInitData',
        afterCacheDifferentHook: () => {
            window.location.reload();
        }
    })();*/
    const viewInitData = await pageInit().catch(generateExceptionRedirector(403, '/request_demo?project=search'));
    // 无 token 为 free, 有 token 无权限也为 free
    isFreeView = isFreeView || get(viewInitData, 'data.isFree', false);
    // 已经 prepareToken 过了, startup不再做 prepareToken 动作
    if (isFreeView) {
        // 在别的产品登录 无法清除analytics域下的token 确保free下去除默认内置拦截器
        passportInterceptManager.eject();
        ejectNodeApiInterceptor();
        // 必须先设置IsFree状态
        setIsFreeView(true);
        [, locale, , commonInitData, , legalConfig] = await startup({
            isFreeView: true,
            headerService,
            projectName: 'Patent View',
            pageInit: () => ({}),
            redirect: '/request_demo?project=search',
            forceSetLocale: forceSetLocale
        });
        psAxios.interceptors.request.use(freeViewRequestSuccessInterceptor, null);
        psAxios.interceptors.request.use(freeViewRequestSignInterceptor, null);
        psAxios.interceptors.request.use(config => {
            config.headers['X-Site-Lang'] = upperCase(locale);
            return config;
        }, null);
        const { logoutHref } = new UserCenterService();
        psAxios.interceptors.response.use(null, error => {
            if (get(error, 'response.status') === 403) {
                window.location.href = `${logoutHref}&errcode=39999&errorType=a4`;
                return error;
            }
            if (get(error, 'response.status') === 429) {
                const i18n = getI18nInstance();
                Toast({ message: i18n.t('freeLimit'), type: 'warning', showClose: true });
            }
            return error;
        });
    } else {
        // 初始化之前执行
        if (beforeInit) await beforeInit();
        [, locale, , commonInitData, , legalConfig] = await startup({
            headerService,
            projectName: 'Patent View',
            pageInit: () => ({}),
            redirect: '/request_demo?project=search',
            forceSetLocale: forceSetLocale
        });
    }

    if (patentId && !isFreeView) {
        new BasicService(patentId).getPatentBase();
    }

    return [get(viewInitData, 'data', {}), commonInitData.globalConfig, locale, headerService, legalConfig.legalConfig];
};
